import MembershipDetail from './MembershipDetailWrap';
export default MembershipDetail;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/MembershipDetail/index.ts